<template>
  <div class="last-articles">
    <div class="line">
      <div>Derniers articles</div>
    </div>
    <div class="row">
      <articles-query :tags="[websiteCategory]">
        <template slot-scope="props">
          <div v-for="article in props.articles">
            <article-preview :article="article"></article-preview>
          </div>
        </template>
        </articles-query>
    </div>
  </div>
</template>

<script>
  import { ArticlesQuery } from 'itrnews-vuejs-api';
  import ArticlePreview from './elements/ArticlePreview';
  import website from '../mixins/Website';

  export default {
    name: 'LastArticles',
    mixins: [website],
    components: { ArticlePreview, ArticlesQuery },
  };
</script>



// WEBPACK FOOTER //
// src/components/LastArticles.vue